import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { initSummaryAB } from '@/services/ab'
import { setupSignupModalEventListeners } from './signup-modal.helpers'

const tableOfContentsJS = require('@/assets.v2/js/tableOfContents.js')
const { tableOfContentsHighlighting, toggleTableOfContents } = tableOfContentsJS

const headerJS = require('@/assets.v2/js/header.js')
const { header } = headerJS

export function initPageSummaryV2(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', async function () {
    header()
    tableOfContentsHighlighting()
    toggleTableOfContents()
    await initSummaryAB()
    setupSignupModalEventListeners()
    Mixpanel.pageView()
  })
}
